// Copyright (C) 2021-Present CITEC Inc. <https://citecsolutions.com/>
// All rights reserved
//
// This file is part of CITEC Inc. source code.
// This software framework contains the confidential and proprietary information
// of CITEC Inc., its affiliates, and its licensors. Your use of these
// materials is governed by the terms of the Agreement between your organization
// and CITEC Inc., and any unauthorized use is forbidden. Except as otherwise
// stated in the Agreement, this software framework is for your internal use
// only and may only be shared outside your organization with the prior written
// permission of CITEC Inc.
// CITEC Inc. source code can not be copied and/or distributed without the express
// permission of CITEC Inc.

import { DocumentsPage } from '@shared/document-management';
import { useAppSelector } from '@advisor-app/store/store';
import {
  selectClient,
  selectClientId,
} from '@shared/data-access/slices/clients/clients-selectors';
import { selectUserId } from '@shared/data-access/slices/user';
import { Navigate } from 'react-router';
import { isDefined } from '@shared/utils';
import { type FC, useMemo } from 'react';

export const Documents: FC = () => {
  const clientId = useAppSelector(selectClientId);
  const activeClient = useAppSelector(selectClient);
  const userId = useAppSelector(selectUserId);

  const canAccessDocuments = useMemo(
    () =>
      isDefined(clientId) &&
      isDefined(userId) &&
      activeClient?.citec_user_id === userId,
    [activeClient?.citec_user_id, clientId, userId],
  );

  if (clientId === null) {
    return <Navigate to="/" replace />;
  }

  if (!canAccessDocuments) {
    return <Navigate to="/aggregation" replace />;
  }

  return <DocumentsPage />;
};

export default Documents;
